import { Button, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import StyledDialog from 'shared/elements/StyledDialog/StyledDialog';
const { ERROR_TEXT, PRIMARY_BUTTON_BORDER, PLAIN_TEXT, DARK_BUTTON_BACKGROUND } = COLORS;

export const AddRepresentativesDialog = styled(StyledDialog)(
  ({ theme, required }: { theme: Theme; required?: boolean }) => ({
    '& .MuiDialog-paper': {
      width: '98% !important',
      height: required ? '90%' : 'fit-content',
      maxWidth: '700px',
      [theme.breakpoints.up(700)]: {
        borderRadius: '8px !important',
        border: theme.palette.type === 'dark' ? '1px solid' : '2px solid',
        borderColor: PRIMARY_BUTTON_BORDER,
      },
    },
  }),
);

export const AddRepresentativesDialogContent = styled('div')(({ theme }) => ({
  padding: '10px 20px',

  [theme.breakpoints.up(700)]: {
    padding: '20px 30px',
  },
}));

export const AddRepresentativesDialogCloseContainer = styled('div')({
  textAlign: 'end',
});

export const AddRepresentativesDialogTitleContainer = styled('div')({
  margin: '20px 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
});

export const AddRepresentativesForm = styled('form')(({ theme }) => ({
  marginTop: 50,
  display: 'grid',
  gap: 20,
  gridTemplateColumns: '1fr 1fr',

  '& > :first-child': {
    gridColumn: 'span 2',
  },

  '& > :nth-child(4), & > :nth-child(5), & > :nth-child(6), & > :nth-child(7)': {
    gridColumn: 'span 2',
  },

  '& > :nth-child(2), & > :nth-child(3)': {
    gridColumn: 'span 2',
  },

  [theme.breakpoints.up(700)]: {
    '& > :nth-child(2), & > :nth-child(3)': {
      gridColumn: 'span 1',
    },
  },
}));

export const AddRepresentativesFormField = styled('div')({
  display: 'grid',
  gap: 15,
  width: '100%',
});

export const AddRepresentativesWarningText = styled('span')({
  fontSize: 12,
  color: ERROR_TEXT,
});

export const AddRepresentativesAction = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: 10,
  [theme.breakpoints.up(700)]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    '& > :nth-child(1), & > :nth-child(2)': {
      gridColumn: 'span 1',
    },
  },
}));

export const AddRepresentativesButton = styled(Button)({
  padding: 15,
  fontWeight: 600,
  '&.MuiButton-containedSecondary': {
    backgroundColor: `${DARK_BUTTON_BACKGROUND} !important`,
    color: PLAIN_TEXT,
  },
});
